import React, { useState, useEffect } from "react";
import UserSurvey01 from "../../../components/templates/UserSurvey/UserSurvey01";
import UserSurvey02 from "../../../components/templates/UserSurvey/UserSurvey02";
import UserSurvey03 from "../../../components/templates/UserSurvey/UserSurvey03";
import UserSurvey04 from "../../../components/templates/UserSurvey/UserSurvey04";
import UserSurvey05 from "../../../components/templates/UserSurvey/UserSurvey05";
// 영문 컴포넌트들
import UserSurvey01En from "../../../components/templates/UserSurvey/UserSurvey01.en";
import UserSurvey02En from "../../../components/templates/UserSurvey/UserSurvey02.en";
import UserSurvey03En from "../../../components/templates/UserSurvey/UserSurvey03.en";
import UserSurvey04En from "../../../components/templates/UserSurvey/UserSurvey04.en";

import moment from "moment";
import "moment/locale/ko";

import { makeStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import {
  Button,
  IconButton,
  Chip,
  Box,
  Typography,
  Switch,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { isEmpty } from "../../../lib/utils";
import session from "../../../lib/sessionStorage";

moment.locale("ko");

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "10px",
  },
  wrapBtn: {
    padding: "10px",
    textAlign: "right",
  },
  download: {
    display: "block",
    color: "#333",
    textAlign: "right",
  },
  userListContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: "1px solid #e0e0e0",
    borderRadius: theme.spacing(1),
  },
  userInputRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  userChip: {
    margin: theme.spacing(0.5),
  },
  bulkInputContainer: {
    marginTop: theme.spacing(2),
  },
}));

const UserSurveyWriteContainer = ({ location, data, applyChecker, lang }) => {
  const classes = useStyles();
  const [section, setSection] = useState({
    UserSurvey01: 1,
    UserSurvey02: 1,
    UserSurvey05: 0,
    UserSurvey03: 1,
    UserSurvey04: 1,
  });
  /** UserSurvey01 */
  const [userName, setUserName] = useState("");
  const [userList, setUserList] = useState([]);
  const [currentUserInput, setCurrentUserInput] = useState("");
  const [bulkUserInput, setBulkUserInput] = useState("");
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [isMultipleMode, setIsMultipleMode] = useState(false);
  const [pxdName, setPxdName] = useState("피엑스디 책임연구원(PM이름)");
  const [email, setEmail] = useState("pxd@pxd.co.kr");
  /** UserSurvey02 */
  const [projectName, setProjectName] = useState("프로젝트");
  const [clientName, setClientName] = useState("클라이언트명");
  // userName
  /** UserSurvey03 */
  /** UserSurvey04 */
  // userName, projectName
  const date = moment().format("LL");
  const [apply, setApply] = useState(false);

  useEffect(() => {
    setApply(false);
  }, [userName, pxdName, email, date, projectName, clientName, userList, section]); 

  useEffect(() => {
    let cnt = 0;
    Object.keys(section).forEach((v, i) => {
      if (section[v] === 1) {
        cnt++;
      }
    });
    if (cnt === 0) {
      alert("1개 이상의 선택이 필요해요.");
      setSection({
        UserSurvey01: 1,
        UserSurvey02: 1,
        UserSurvey03: 1,
        UserSurvey04: 1,
        UserSurvey05: 1,
      });
    }
  }, [section]);

  const handleChange = (e) => {
    setSection({
      ...section,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  // 대상자 추가 함수
  const addUser = (inputValue = currentUserInput) => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !userList.includes(trimmedValue)) {
      setUserList((prevList) => [...prevList, trimmedValue]);
      setCurrentUserInput("");
    }
  };

  // 대상자 삭제 함수
  const removeUser = (userToRemove) => {
    setUserList(userList.filter((user) => user !== userToRemove));
  };

  // 일괄 입력 처리 함수
  const handleBulkAdd = () => {
    const names = bulkUserInput
      .split(/[,\n]/)
      .map((name) => name.trim())
      .filter((name) => name && !userList.includes(name));

    setUserList([...userList, ...names]);
    setBulkUserInput("");
    setIsBulkMode(false);
  };

  // 모드 전환 함수
  const handleModeSwitch = (event) => {
    const newMode = event.target.checked;
    setIsMultipleMode(newMode);

    // 다중 모드에서 단일 모드로 전환 시 초기화
    if (!newMode) {
      setUserList([]);
      setCurrentUserInput("");
      setBulkUserInput("");
      setIsBulkMode(false);
    }
  };

  // 이메일 체크
  const isEmail = (value) => {
    let regExp =
      /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    return regExp.test(value); // 형식에 맞는 경우 true 리턴
  };

  // 핸드폰 번호 체크
  const isCelluar = (value) => {
    let regExp = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
    return regExp.test(value); // 형식에 맞는 경우 true 리턴
  };

  const onApply = () => {
    let el = document.querySelectorAll("[name=text-field]");
    let el_arr = [...el];
    let checker = false;

    el_arr.some((v, i) => {
      if (isEmpty(v.value)) {
        checker = false;
        v.focus();
        return true;
      } else {
        checker = true;
      }
    });

    if (!isEmail(email)) {
      alert("이메일 형식에 맞게 입력하세요.");
      let el = document.querySelector(".email input");
      el.focus();
      return false;
    }

    // 대상자 목록 확인 (모드에 따라 다르게 처리)
    let targetUsers;
    if (isMultipleMode) {
      targetUsers = userList;
      if (targetUsers.length === 0) {
        alert("다중 모드에서는 최소 1명 이상의 대상자를 추가해주세요.");
        return false;
      }
    } else {
      targetUsers = [userName];
      if (isEmpty(userName)) {
        alert("대상자 이름을 입력해주세요.");
        return false;
      }
    }

    if (checker) {
      // 다중 대상자를 위한 데이터 배열 생성
      let sendDataArray = targetUsers.map((user) => ({
        sign_type: "sign",
        project: projectName,
        major_nm: clientName,
        minor_nm: user,
        officer_nm: pxdName,
        officer_mail: email,
        language: lang,
        section_data: [
          {
            section_nm: "UserSurvey01",
            section_flag: section.UserSurvey01,
          },
          {
            section_nm: "UserSurvey02",
            section_flag: section.UserSurvey02,
          },
          {
            section_nm: "UserSurvey03",
            section_flag: section.UserSurvey03,
          },
          {
            section_nm: "UserSurvey04",
            section_flag: section.UserSurvey04,
          },
          {
          section_nm: "UserSurvey05",
          section_flag: section.UserSurvey05,
        },
        ],
        user_idx: JSON.parse(session.get("userIdx")),
      }));

      console.log("UserSurvey sendDataArray:", sendDataArray);
      console.log("isMultipleMode:", isMultipleMode);

      applyChecker(checker);
      setApply(checker);

      // 단일 모드면 첫 번째 객체만, 다중 모드면 배열 전체 전달
      if (isMultipleMode) {
        data(sendDataArray);
      } else {
        data(sendDataArray[0]);
      }
    }
  };

  return (
    <div className={classes.wrapper}>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              name="UserSurvey01"
              checked={section.UserSurvey01 === 1}
              onChange={handleChange}
            />
          }
          label="Intro"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="UserSurvey02"
              checked={section.UserSurvey02 === 1}
              onChange={handleChange}
            />
          }
          label="개인정보수집/제공"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="UserSurvey05"
              checked={section.UserSurvey05 === 1}
              onChange={handleChange}
            />
          }
          label="KB증권(개인정보수집/제공)"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="UserSurvey03"
              checked={section.UserSurvey03 === 1}
              onChange={handleChange}
            />
          }
          label="사례비 지급"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="UserSurvey04"
              checked={section.UserSurvey04 === 1}
              onChange={handleChange}
            />
          }
          label="비밀유지계약서"
        />
      </FormGroup>

      {lang === "en" ? (
        <a
          href="/files/사용자조사 개인정보 관련_영문.docx"
          className={classes.download}
          download
        >
          Word(English) File Download
        </a>
      ) : (
        <a
          href="/files/사용자조사_개인정보_관련.docx"
          className={classes.download}
          download
        >
          Word 문서 다운로드
        </a>
      )}

      <div>
        <Table aria-label="table">
          <TableBody>
            <TableRow>
              <TableCell>대상자</TableCell>
              <TableCell>
                <div className={classes.userListContainer}>
                  {/* 모드 전환 스위치 */}
                  <Box mb={2}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isMultipleMode}
                          onChange={handleModeSwitch}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="subtitle2">
                          {isMultipleMode ? "다중 작성" : "단일 작성"}
                          {isMultipleMode && ` (${userList.length}명)`}
                        </Typography>
                      }
                    />
                  </Box>

                  {/* 단일 대상자 모드 */}
                  {!isMultipleMode && (
                    <TextField
                      label="대상자 이름"
                      name="text-field"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      fullWidth
                      placeholder="예: 홍길동"
                    />
                  )}

                  {/* 다중 대상자 모드 */}
                  {isMultipleMode && (
                    <>
                      {/* 개별 추가 */}
                      <div className={classes.userInputRow}>
                        <TextField
                          label="대상자 이름 추가"
                          value={currentUserInput}
                          onChange={(e) => setCurrentUserInput(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              addUser(e.target.value);
                            }
                          }}
                          size="small"
                          style={{ flex: 1 }}
                          placeholder="이름 입력 후 Enter 또는 + 버튼"
                        />
                        <IconButton
                          onClick={() => addUser(currentUserInput)}
                          color="primary"
                          disabled={!currentUserInput.trim()}
                          title="대상자 추가"
                        >
                          <AddIcon />
                        </IconButton>
                        {/* <Button
                          size="small"
                          onClick={() => setIsBulkMode(!isBulkMode)}
                          variant="outlined"
                        >
                          {isBulkMode ? "개별입력" : "일괄입력"}
                        </Button> */}
                      </div>

                      {/* 일괄 입력 모드 */}
                      {isBulkMode && (
                        <div className={classes.bulkInputContainer}>
                          <TextField
                            label="여러 이름을 쉼표(,) 또는 줄바꿈으로 구분하여 입력"
                            multiline
                            rows={4}
                            value={bulkUserInput}
                            onChange={(e) => setBulkUserInput(e.target.value)}
                            fullWidth
                            placeholder="홍길동, 김철수, 이영희&#10;또는&#10;홍길동&#10;김철수&#10;이영희"
                          />
                          <Box mt={1}>
                            <Button
                              onClick={handleBulkAdd}
                              color="primary"
                              variant="contained"
                              size="small"
                              style={{ marginRight: 8 }}
                            >
                              추가
                            </Button>
                            <Button
                              onClick={() => {
                                setIsBulkMode(false);
                                setBulkUserInput("");
                              }}
                              size="small"
                            >
                              취소
                            </Button>
                          </Box>
                        </div>
                      )}

                      {/* 추가된 대상자 목록 */}
                      {userList.length > 0 && (
                        <Box mt={2}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            gutterBottom
                          >
                            추가된 대상자:
                          </Typography>
                          <Box>
                            {userList.map((user, index) => (
                              <Chip
                                key={index}
                                label={user}
                                onDelete={() => removeUser(user)}
                                className={classes.userChip}
                                color="primary"
                                variant="outlined"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>PXD 책임자</TableCell>
              <TableCell>
                <TextField
                  label="이름"
                  name="text-field"
                  onChange={(e) => setPxdName(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>PXD 책임자 E-Mail</TableCell>
              <TableCell>
                <TextField
                  className="email"
                  label="pxd@pxd.co.kr"
                  name="text-field"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" style={{ width: 160 }}>
                프로젝트명
              </TableCell>
              <TableCell>
                <TextField
                  label="프로젝트명"
                  name="text-field"
                  onChange={(e) => setProjectName(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>클라이언트명</TableCell>
              <TableCell>
                <TextField
                  label="이름"
                  name="text-field"
                  onChange={(e) => setClientName(e.target.value)}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <div className={classes.wrapBtn}>
          <Button
            variant="contained"
            color="primary"
            disabled={apply}
            startIcon={<CreateIcon />}
            onClick={onApply}
          >
            Apply
          </Button>
        </div>
      </div>
      {Object.keys(section).map((v, i) => {
        // 언어에 따라 적절한 컴포넌트 선택
        const isEnglish = lang === "en";

        switch (v) {
          case "UserSurvey01":
            return (
              section[v] === 1 &&
              (isEnglish ? (
                <UserSurvey01En
                  key={i}
                  mode="write"
                  userName={userName}
                  pxdName={pxdName}
                  email={email}
                  date={date}
                />
              ) : (
                <UserSurvey01
                  key={i}
                  mode="write"
                  userName={userName}
                  pxdName={pxdName}
                  email={email}
                  date={date}
                />
              ))
            );
          case "UserSurvey02":
            return (
              section[v] === 1 &&
              (isEnglish ? (
                <UserSurvey02En
                  key={i}
                  mode="write"
                  projectName={projectName}
                  clientName={clientName}
                  date={date}
                  userName={userName}
                />
              ) : (
                <UserSurvey02
                  key={i}
                  mode="write"
                  projectName={projectName}
                  clientName={clientName}
                  date={date}
                  userName={userName}
                />
              ))
            );
          case "UserSurvey05":
            return (
              section[v] === 1 && (
                <UserSurvey05
                  key={i}
                  mode="write"
                  userName={userName}
                  projectName={projectName}
                  date={date}
                />
              )
            );
          case "UserSurvey03":
            return (
              section[v] === 1 &&
              (isEnglish ? (
                <UserSurvey03En key={i} mode="write" />
              ) : (
                <UserSurvey03 key={i} mode="write" />
              ))
            );
          case "UserSurvey04":
            return (
              section[v] === 1 &&
              (isEnglish ? (
                <UserSurvey04En
                  key={i}
                  mode="write"
                  userName={userName}
                  projectName={projectName}
                  date={date}
                />
              ) : (
                <UserSurvey04
                  key={i}
                  mode="write"
                  userName={userName}
                  projectName={projectName}
                  date={date}
                />
              ))
            );
          default:
            break;
        }

        // return section[v] === 1 && <Component />
      })}
      {/*{ section.UserSurvey01 === 1 && <UserSurvey01 mode="write" userName={userName} pxdName={pxdName} email={email} date={date}/> }*/}
      {/*{ section.UserSurvey02 === 1 && <UserSurvey02 mode="write" projectName={projectName} clientName={clientName} date={date} userName={userName}/> }*/}
      {/*{ section.UserSurvey03 === 1 && <UserSurvey03 mode="write"/> }*/}
      {/*{ section.UserSurvey04 === 1 && <UserSurvey04 mode="write" userName={userName} projectName={projectName} date={date}/> }*/}
    </div>
  );
};

export default UserSurveyWriteContainer;
